<template>
  <intro-template
    @start="next"
    button-label="Découvrir comment déclencher le paiement dans GTA"
    duration="2">
    <template v-slot:module-title>
      Déclencher le paiement des heures excédentaires
    </template>
    <template v-slot:learnings-title>
      Dans ce module, vous allez apprendre à...
    </template>
    <template v-slot:learnings>
      <p>Déclencher le paiement des heures excédentaires via la GTA</p>
    </template>
    <template v-slot:rules>
      <div class="rule">
        <p class="label">
          Visionnez
        </p>
        <p class="value">
          un tutoriel
        </p>
      </div>
      <div class="rule">
        <p class="label">
          Saisissez
        </p>
        <p class="value">
          les paiements
        </p>
      </div>
    </template>
  </intro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Intro',
  mixins: [stepMixin]
}
</script>
